export enum TruckColumns {
  TruckName = 0,
  TruckAlias = 1
}
export const TruckColumnsMapping: Record<TruckColumns, string> = {
  [TruckColumns.TruckName]: 'Truck Name',
  [TruckColumns.TruckAlias]: 'FedEx #'
};
